import { Grid, Typography } from "@mui/material";

const SummaryCard = (props) => {
  const {
    protocolNumber,
    protocolNumber2,
    status,
    created,
    updated,
    submitted,
    type,
    season,
  } = props;
  return (
    <Grid sx={{ padding: 4 }} container className="card">
      <Grid align="center" item xs={12}>
        <strong>ΣΤΟΙΧΕΙΑ ΑΙΤΗΣΗΣ</strong>
      </Grid>
      <Grid sx={{ padding: 2 }} align="center" item xs={12} mb={1}>
        <Typography variant="h5">
          Παροχή Χρηματικών Βοηθημάτων
          σε τρίτεκνες/ πολύτεκνες μητέρες και μονογονείς πατέρες του ΛΑΕ/ΟΠΕΚΑ έτους {season}.
        </Typography>
        <Typography>
          Η παρούσα αίτηση επέχει θέση Υπεύθυνης Δήλωσης για την ακρίβεια των
          δηλωθέντων στοιχείων. Η ακρίβεια των στοιχείων που υποβάλλονται με
          αυτή την αίτηση, μπορεί να ελεγχθεί με βάση το αρχείο άλλων υπηρεσιών
          (άρθρο 8 παρ. 4 Ν. 1599/1986)
        </Typography>
      </Grid>
      <Grid container item xs={12}>
        <Grid container item xs={12} md={6}>
          <Grid item xs={6} mb={1}>
            <Typography>Τύπος αίτησης:</Typography>
          </Grid>
          <Grid item xs={6} mb={1}>
            <Typography fontWeight="bold">{type?.name}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={6} mb={1}>
          <Typography>Κατ. Αίτησης:</Typography>
        </Grid>
        <Grid item xs={6} mb={1}>
          <Typography fontWeight="bold">{status?.name} </Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={6} mb={1}>
          <Typography>Ημ. Δημιουργίας</Typography>
        </Grid>
        <Grid item xs={6} mb={1}>
          <Typography fontWeight="bold">{created?.dateFormatted}</Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={6} mb={1}>
          <Typography>A/A Υποβολής:</Typography>
        </Grid>
        <Grid item xs={6} mb={1}>
          <Typography fontWeight="bold">
            {protocolNumber ?? "(δίνεται μετά την Υποβολή)"}
          </Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={6}>
          <Typography>Ημ. Υποβολής:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography fontWeight="bold">
            {submitted?.dateFormatted ?? ""}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SummaryCard;
